import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 24,
  },
  button: {
    marginTop: theme.spacing(4),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/PaymentMethod/useStyles.js